var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-28",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.86343 2.36195C2.74343 1.43495 3.05443 1.17495 3.42943 1.05395C3.68895 0.985949 3.96112 0.982174 4.22243 1.04295C4.56643 1.14295 4.65743 1.21895 5.78543 2.34295C6.77643 3.32995 6.87543 3.43695 6.97043 3.62995C7.15208 3.96873 7.18046 4.36894 7.04843 4.72995C6.94843 5.00495 6.80643 5.18695 6.20543 5.78995L5.81343 6.18295C5.71048 6.28757 5.68629 6.44643 5.75343 6.57695C6.62437 8.06281 7.86 9.30189 9.34343 10.177C9.51418 10.2684 9.72445 10.2389 9.86343 10.104L10.2404 9.73295C10.4734 9.4941 10.7202 9.26905 10.9794 9.05895C11.3866 8.80896 11.8939 8.78666 12.3214 8.99995C12.5304 9.09995 12.5994 9.16195 13.6214 10.182C14.6754 11.233 14.7054 11.266 14.8214 11.507C15.0397 11.9059 15.0374 12.3891 14.8154 12.786C14.7024 13.01 14.6334 13.091 14.0404 13.697C13.6824 14.063 13.3454 14.397 13.2914 14.446C12.8022 14.851 12.1746 15.0497 11.5414 15C10.383 14.8944 9.26169 14.5363 8.25643 13.951C6.02956 12.7711 4.13383 11.0521 2.74243 8.95095C2.43937 8.51122 2.16994 8.04924 1.93643 7.56895C1.31001 6.49532 0.986529 5.27189 1.00043 4.02895C1.04825 3.37871 1.36008 2.77637 1.86343 2.36195Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.0aa205d0f02242c9be724f346f8da95a.svg";
export { ForwardRef as ReactComponent };